// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UiGrid_wrapper__3-G_x"};